import styled from "styled-components";

export const Button = styled.button`
  align-self: flex-end;
  color: white;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.375rem;
  padding: 10px 15px;
  background: ${ props => props.disabled ? '#707070' : props.bg };
  border: none;
  border-radius: 5px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer' };
  :hover {
    opacity: .95;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .16);
  }
`